import React, { type InputHTMLAttributes } from "react";
import { Field } from "redux-form";
import FileUploadRenderer from "src/shared/forms/formrenderers/FileUploadRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import { required as Required } from "src/shared/forms/validations/Required";

export interface IFileInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLInputElement> {}

export const FileInputOld = (props: IFileInputProps) => {
  const { inputID, label, validationDisabled, ...rest } = props;
  return (
    <Field
      name={inputID}
      label={label}
      component={FileUploadRenderer}
      validate={!validationDisabled ? [Required] : undefined}
      {...rest}
    />
  );
};
